module.exports = __webpack_public_path__ + "static/lightbulb-square.8ba7e9df.jpg";